<div class="container p-3">
    <h1>DHL DE Onboarding</h1>

    <p>Verbinden Sie Ihr Händlerkonto mit DHL.</p>

    @if (!loading() && hasCallbackError()) {
        <div class="text-center pt-3">
            <ngb-alert type="danger" [dismissible]="false"
                >Die DHL-Verbindung konnte nicht abgeschlossen werden.</ngb-alert
            >
        </div>
    }

    @if (!loading() && hasError()) {
        <div class="text-center pt-3">
            <ngb-alert type="danger" [dismissible]="false">Fehler beim Laden der Daten.</ngb-alert>
        </div>
    }

    @if (loading()) {
        <div class="text-center general-spinner my-4">
            <div class="spinner-border text-danger" role="status"></div>
        </div>
    } @else {
        @let response = dhlAuthInfo();

        @if (response?.status !== 'OK') {
            <button class="btn btn-lg fw-bold mmp-btn bg-primary" (click)="connectToDhl()" [disabled]="disableButton()">
                @if (isButtonClickLoading()) {
                    <div class="spinner-border text-light" role="status"></div>
                }
                {{ response?.status === 'EXPIRED' ? 'Erneut mit DHL verbinden' : 'Mit DHL verbinden' }}
            </button>
        }
        @if (!hasError()) {
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <th scope="row">Status</th>
                        <td>
                            <div
                                class="status fw-bold header-content"
                                [class.bg-success]="response?.status === 'OK'"
                                [class.bg-warning]="response?.status === 'EXPIRED'"
                                [class.bg-secondary]="response?.status === 'NOT_CONNECTED'"
                            >
                                {{ statusLabel(response?.status) }}
                            </div>
                            <div class="status-panel card bg-light my-2">
                                <div class="card-body">
                                    <div class="body-content">
                                        {{ statusInfo(response?.status) }}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    @if (response?.status === 'OK' && response?.expiresAt) {
                        <tr>
                            <th scope="row">Token läuft ab am:</th>
                            <td>
                                {{ response?.expiresAt | date: 'dd.MM.yyyy HH:mm' }}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        }
    }
</div>
